// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';
import { Base, Radio, Help } from '@gandi/ui';

type Props = {
  translator: TranslatorProps,
  onChange: (value: boolean) => mixed,
};

function BecomeReseller(props: Props): React.Node {
  const {
    translator: { __ },
    onChange,
  } = props;

  const name = 'become-reseller';
  const handleChange = React.useCallback(
    (evt: SyntheticInputEvent<>) => {
      onChange(evt.target.value === 'yes');
    },
    [onChange],
  );

  return (
    <Base
      padding="small"
      backgroundColor="surface"
      aria-describedby="become-reseller"
    >
      <Base weight="semibold" marginBottom="xsmall" id="become-reseller">
        {__('Will you resell products with this organization?')}
      </Base>
      <Radio
        name={name}
        id="no"
        value="no"
        defaultChecked
        onChange={handleChange}
        marginBottom="xsmall"
      >
        {__('No')}
      </Radio>
      <Radio name={name} id="yes" value="yes" onChange={handleChange}>
        {__('Yes, I am a reseller')}
      </Radio>
      <Help variant="radio">
        {__(
          "My business requires that my customers purchase and manage their domains exclusively through my services, and not via Gandi's website.",
        )}
      </Help>
    </Base>
  );
}

export default (React.memo<Props>(BecomeReseller): React.ComponentType<Props>);
